import { Button, Divider, Input, notification, Tooltip } from "antd";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import { Formik } from "formik";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { MessageBar, MessageBarType } from "@fluentui/react";
import React, { createContext, useContext, useEffect } from "react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import MonthlymonthlySettingStore from "../store/monthlysettingstore";
import moment from "moment";
const monthlySettingStoreCtx = createContext(MonthlymonthlySettingStore);
export const InputDeckSettings = observer(() => {
  const monthlySettingStore = useContext(monthlySettingStoreCtx);
  useEffect(() => {
    async function loadSettings() {
      try {
        await monthlySettingStore.loadMonthlyDeckSettings();
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: `download failed,${error.message}`,
        });
      }
    }
    loadSettings();
  }, []);
  return (
    <Formik
      initialValues={toJS(monthlySettingStore.monthlySettings)}
      enableReinitialize={true}
    >
      {({ values }) => (
        <Form
          layout="horizontal"
          labelAlign="left"
          style={{ background: "#fff", padding: "10px" }}
        >
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm9">
              <SubPageHeaderTitle title="Well/String Input Deck Configurations" />
              <div>Excel Worksheet Cell Address</div>
            </div>
            <div className="ms-Grid-col ms-sm3" style={{ textAlign: "right" }}>
              <Button
                type="primary"
                disabled={!monthlySettingStore.isSettingsModified}
                loading={monthlySettingStore.isSaving}
                onClick={async () => {
                  try {
                    const res = await monthlySettingStore.saveMonthlyDeckSettings();
                    if (res.success) {
                      monthlySettingStore.isSettingsModified = false;
                      monthlySettingStore.monthlySettings = res.setting;
                      monthlySettingStore.isSaving = false;
                      notification.success({
                        message: "SPARS Feedback",
                        description:
                          "Monthly Input deck settings modification saved successfully",
                      });
                    }
                  } catch (error) {
                    notification.error({
                      message: "SPARS Feedback",
                      description: `download failed,${error.message}`,
                    });
                  } finally {
                    monthlySettingStore.isSaving = false;
                  }
                }}
              >
                Save Modifiations
              </Button>
            </div>
          </div>

          <div className="ms-Grid-row">
            <Divider>Well/String Production (Table)</Divider>
            <div>
              <span style={{ color: "red", fontStyle: "italic" }}>
                exclude the deck tables headers and units (FIELD,WELL,Level,Days
                On e.t.c) row
              </span>
            </div>
            <div className="ms-Grid-col ms-sm3">
              <Tooltip title="Row Start Table Cell Address  ">
                {" "}
                <FormItem
                  label="Row Start"
                  labelAlign="left"
                  className="add-border"
                >
                  <Input
                    style={{ minWidth: "60%" }}
                    name="volumeRowStartAddress"
                    value={values?.volumeRowStartAddress}
                    onChange={({ target: { value } }) => {
                      monthlySettingStore.monthlySettings.volumeRowStartAddress = value;
                      monthlySettingStore.isSettingsModified = true;
                    }}
                  />
                </FormItem>
              </Tooltip>
            </div>
            <div className="ms-Grid-col ms-sm3">
              <Tooltip title="Row End Table Cell Address    ">
                {" "}
                <FormItem
                  label="Row End"
                  labelAlign="left"
                  className="add-border"
                >
                  <Input
                    style={{ minWidth: "60%" }}
                    name="volumeRowEndAddress"
                    value={values?.volumeRowEndAddress}
                    onChange={({ target: { value } }) => {
                      monthlySettingStore.monthlySettings.volumeRowEndAddress = value;
                      monthlySettingStore.isSettingsModified = true;
                    }}
                  />
                </FormItem>
              </Tooltip>
            </div>
            <div className="ms-Grid-col ms-sm3">
              <Tooltip title="Column Start  Table Cell Address ">
                {" "}
                <FormItem
                  label="Column Start "
                  labelAlign="left"
                  className="add-border"
                >
                  <Input
                    style={{ minWidth: "60%" }}
                    name="volumeColStartAddress"
                    value={values?.volumeColStartAddress}
                    onChange={({ target: { value } }) => {
                      monthlySettingStore.monthlySettings.volumeColStartAddress = value;
                      monthlySettingStore.isSettingsModified = true;
                    }}
                  />
                </FormItem>
              </Tooltip>
            </div>
            <div className="ms-Grid-col ms-sm3">
              <Tooltip title="Column End  Table Cell Address">
                {" "}
                <FormItem
                  label="Column End"
                  labelAlign="left"
                  className="add-border"
                >
                  <Input
                    style={{ minWidth: "60%" }}
                    name="volumeColEndAddress"
                    value={values?.volumeColEndAddress}
                    onChange={({ target: { value } }) => {
                      monthlySettingStore.monthlySettings.volumeColEndAddress = value;
                      monthlySettingStore.isSettingsModified = true;
                    }}
                  />
                </FormItem>
              </Tooltip>
            </div>
          </div>
          <div className="ms-Grid-row">
            <Divider>Well/String Subsurface Parameters (Table)</Divider>
            <div>
              <span style={{ color: "red", fontStyle: "italic" }}>
                exclude the deck tables headers and units (FIELD,WELL,Level,Days
                On e.t.c) row
              </span>
            </div>
            <div className="ms-Grid-col ms-sm3">
              <Tooltip title=" Row Start  Table Cell Address  ">
                {" "}
                <FormItem
                  label="Row Start"
                  labelAlign="left"
                  className="add-border"
                >
                  <Input
                    style={{ minWidth: "60%" }}
                    name="rateRowStartAddress"
                    value={values?.rateRowStartAddress}
                    onChange={({ target: { value } }) => {
                      monthlySettingStore.monthlySettings.rateRowStartAddress = value;
                      monthlySettingStore.isSettingsModified = true;
                    }}
                  />
                </FormItem>
              </Tooltip>
            </div>
            <div className="ms-Grid-col ms-sm3">
              <Tooltip title=" Row End Table Cell Address    ">
                {" "}
                <FormItem
                  label="Row End"
                  labelAlign="left"
                  className="add-border"
                >
                  <Input
                    style={{ minWidth: "60%" }}
                    name="rateRowEndAddress"
                    value={values?.rateRowEndAddress}
                    onChange={({ target: { value } }) => {
                      monthlySettingStore.monthlySettings.rateRowEndAddress = value;
                      monthlySettingStore.isSettingsModified = true;
                    }}
                  />
                </FormItem>
              </Tooltip>
            </div>
            <div className="ms-Grid-col ms-sm3">
              <Tooltip title=" Column Start Table Cell Address     ">
                {" "}
                <FormItem
                  label="Column Start "
                  labelAlign="left"
                  className="add-border"
                >
                  <Input
                    style={{ minWidth: "60%" }}
                    name="rateColStartAddress"
                    value={values?.rateColStartAddress}
                    onChange={({ target: { value } }) => {
                      monthlySettingStore.monthlySettings.rateColStartAddress = value;
                      monthlySettingStore.isSettingsModified = true;
                    }}
                  />
                </FormItem>
              </Tooltip>
            </div>
            <div className="ms-Grid-col ms-sm3">
              <Tooltip title=" Column End Table Cell Address    ">
                {" "}
                <FormItem
                  label="Column End"
                  labelAlign="left"
                  className="add-border"
                >
                  <Input
                    style={{ minWidth: "60%" }}
                    name="rateColEndAddress"
                    value={values?.rateColEndAddress}
                    onChange={({ target: { value } }) => {
                      monthlySettingStore.monthlySettings.rateColEndAddress = value;
                      monthlySettingStore.isSettingsModified = true;
                    }}
                  />
                </FormItem>
              </Tooltip>
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm9">
              <MessageBar messageBarType={MessageBarType.info}>
                last modified by{" "}
                {monthlySettingStore?.monthlySettings?.uploadedBy} on{" "}
                {moment(
                  monthlySettingStore?.monthlySettings?.uploadedOn
                ).format("MMMM Do YYYY, h:mm:ss a")}
              </MessageBar>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
});

